import { render, staticRenderFns } from "./unsealServer.vue?vue&type=template&id=2aa52d26&scoped=true&"
import script from "./unsealServer.vue?vue&type=script&lang=js&"
export * from "./unsealServer.vue?vue&type=script&lang=js&"
import style0 from "./unsealServer.vue?vue&type=style&index=0&id=2aa52d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa52d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa52d26')) {
      api.createRecord('2aa52d26', component.options)
    } else {
      api.reload('2aa52d26', component.options)
    }
    module.hot.accept("./unsealServer.vue?vue&type=template&id=2aa52d26&scoped=true&", function () {
      api.rerender('2aa52d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/banUser/components/unsealServer.vue"
export default component.exports